import React, { ReactElement } from 'react';

import './NotificationSection.less';

export enum NotificationType {
    INFO = 'info',
    WARNING = 'warning',
    SUCCESS = 'success',
    ERROR = 'error'
}

interface Props {
    type: NotificationType;
    mainContent: ReactElement | Array<ReactElement> | string;
    headline?: string;
    footer?: ReactElement;
}

const NotificationSection = ({ type, mainContent, headline, footer }: Props): ReactElement => (
    <div className={`notification-section ${type}`}>
        {headline && <div className="headline-section">{headline}</div>}
        <div>{mainContent}</div>
        {footer && <div className="footer-section">{footer}</div>}
    </div>
);

export default NotificationSection;
